import {mapActions} from "vuex";


export default {
    last: '',
    methods: {
        ...mapActions('menu', [
            'setHidden',
            'setType',
            'enableSingleSearch',
            'disableSingleSearch',
            'resetAllSearch'
        ]),
        ...mapActions('search', [
            'clearSearch',
            'closeSearch'
        ]),
        getFirstLetter(name) {
            return name.charAt(0)
        },
        isNewLetter(name) {
            let current = this.getFirstLetter(name);
            if (current !== this.last) {
                this.last = current;
                return true;
            }
            return false;
        }
    },
    mounted() {
    },

    beforeDestroy() {
        this.disableSingleSearch()
    }
}
